import React, { useCallback, useEffect, useMemo, useState } from 'react'
import NonlalinService from '../../../services/nonlalin/NonlalinService'
import MasterService from '../../../services/master/MasterService'
import UserService from '../../../services/user/UserService'
import PbUmkuService from '../../../services/pbumku/PbumkuService'
import { formatDateString, getCurrentDateFormatted, getNamaUPTBaru, romanNum } from '../../../utilities/Utils'
import { Button, Modal, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import NonlalinDisposisi from '../../../utilities/nonlalin/NonlalinDisposisi'
import SweetAlert from 'react-bootstrap-sweetalert'
import DataTable from 'react-data-table-component'
import ExpandableComponentNonLalinPeriksa from '../expand/ExpandableComponentNonLalinPeriksa'
import ModalTargetUji from './ModalTargetUji'
import { FaRegPlusSquare } from 'react-icons/fa'

const ModalProsesNonLalin = ({ showAddProses, handleCloseAddProses, dataDisposisi, datappm, reloadList, isEdit }) => {
    const [showConfirmProses, setShowConfirmProses] = useState(false)
    const handleCloseConfirmProses = () => setShowConfirmProses(false)
    const [showProsesSuccess, setShowProsesSucces] = useState(false)
    const [showProsesFailed, setShowProsesFailed] = useState(false)
    const [rowData, setRowData] = useState(null)

    let nonLalinService = useMemo(() => new NonlalinService(), [])
    let masterService = useMemo(() => new MasterService(), [])
    let userService = useMemo(() => new UserService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    const [jnsKomoditi, setJnsKomoditi] = useState(null)
    const [maksudKegiatan, setMaksudKegiatan] = useState(null)
    const [upt, setUpt] = useState(null)

    const [dataDetil, setDataDetil] = useState(null)

    const [loadingSave, setLoadingSave] = useState(false)

    const fetchAllData = useCallback(async () => {
        try {
            const resJenisKomoditi = await masterService.getJenisKomoditiById(datappm.jenisKomoditi)
            setJnsKomoditi(resJenisKomoditi.data.jenisKomoditi)

            const resMaksud = await nonLalinService.getRefNonlalinMaksudKegiatanById(datappm.maksudKegiatan)
            setMaksudKegiatan(resMaksud.data.urMaksudKegiatan)

            const resUpt = await userService.getUptById(datappm.kodeUpt)
            setUpt(getNamaUPTBaru(datappm.tanggalAju, resUpt.data))

            const resDetil = await nonLalinService.listNonlalinDtlAll(datappm.nomorAju)
            setDataDetil(resDetil.data)

        } catch (error) {
            setJnsKomoditi(null)
            setMaksudKegiatan(null)
        }
    }, [masterService, nonLalinService, userService, datappm])
    // let navigate = useNavigate()
    useEffect(() => {
        if (!datappm) return
        fetchAllData()
    }, [datappm, fetchAllData])

    const ProsesDisposisi = (dataPenugasan) => {
        setShowConfirmProses(true)
        setRowData(dataPenugasan)
    }

    const handleClickProses = async () => {
        setLoadingSave(true)
        try {
            // console.log(datappm)
            // let jsonSppLhp = {
            //     idDisposisi: 2,
            //     nomorAju: datappm.nomorAju
            // }

            let jsonPnbp = {
                idDisposisi: 5,
                nomorAju: datappm.nomorAju
            }

            const respNomor = await pbumkuService.ambilNomorService('NLL_PROSES', datappm.kodeUpt, currentYear, localStorage.getItem('username'))
            let noSuratTugasTemp = respNomor.data.uraianPusat + '/' + respNomor.data.kodePusat + '/' + romanNum(currentMonth) + '/' + currentYear + '/' + respNomor.data.nomorUrut
            let jsonProses = { ...rowData, noTugas: noSuratTugasTemp, tglTugas: getCurrentDateFormatted(), createdBy: localStorage.getItem("userId") }

            // if (datappm.maksudKegiatan === "5" || datappm.maksudKegiatan === "6") {
            let response = await nonLalinService.saveNonlalinPenugasan(jsonPnbp)
            // } else {
            //     response = await nonLalinService.saveNonlalinPenugasan(jsonSppLhp)
            // }
            if (response.data.kode === '200') {
                setShowProsesSucces(true)
                setShowConfirmProses(false)
                await nonLalinService.saveNonlalinPenugasan(jsonProses)

                let dataStatus;

                if (datappm.maksudKegiatan === "5" || datappm.maksudKegiatan === "6") {
                    let jsonppm = { ...datappm, status: '027' }
                    await nonLalinService.saveNonlalinHeader(jsonppm)
                    dataStatus = {
                        nomorAju: datappm.nomorAju,
                        kodeStatus: '027',
                        waktuStatus: new Date(),
                        createdBy: localStorage.getItem('username')
                    }
                    await nonLalinService.saveNonlalinStatus(JSON.stringify(dataStatus))
                } else if (datappm.maksudKegiatan === "2") {
                    let jsonppm = { ...datappm, status: '027' }
                    await nonLalinService.saveNonlalinHeader(jsonppm)
                    dataStatus = {
                        nomorAju: datappm.nomorAju,
                        kodeStatus: '027',
                        waktuStatus: new Date(),
                        createdBy: localStorage.getItem('username')
                    }
                    await nonLalinService.saveNonlalinStatus(JSON.stringify(dataStatus))

                    let jsonSppScan = {
                        idDisposisi: 16,
                        nomorAju: datappm.nomorAju
                    }
                    await nonLalinService.saveNonlalinPenugasan(jsonSppScan)
                    
                    let jsonSppSample = {
                        idDisposisi: 17,
                        nomorAju: datappm.nomorAju
                    }
                    await nonLalinService.saveNonlalinPenugasan(jsonSppSample)
                } else {
                    let jsonppm = { ...datappm, status: '027' }
                    await nonLalinService.saveNonlalinHeader(jsonppm)

                    dataStatus = {
                        nomorAju: datappm.nomorAju,
                        kodeStatus: '020',
                        waktuStatus: new Date(),
                        createdBy: localStorage.getItem('username')
                    }
                    await nonLalinService.saveNonlalinStatus(JSON.stringify(dataStatus))
                    dataStatus = {
                        nomorAju: datappm.nomorAju,
                        kodeStatus: '027',
                        waktuStatus: new Date(),
                        createdBy: localStorage.getItem('username')
                    }
                    await nonLalinService.saveNonlalinStatus(JSON.stringify(dataStatus))

                    let jsonBast = {
                        idDisposisi: 3,
                        nomorAju: datappm.nomorAju
                    }
                    await nonLalinService.saveNonlalinPenugasan(jsonBast)
                    dataStatus = {
                        nomorAju: datappm.nomorAju,
                        kodeStatus: '023',
                        waktuStatus: new Date(),
                        createdBy: localStorage.getItem('username')
                    }
                    await nonLalinService.saveNonlalinStatus(JSON.stringify(dataStatus))

                    let jsonSppLhp = {
                        idDisposisi: 2,
                        nomorAju: datappm.nomorAju
                    }
                    await nonLalinService.saveNonlalinPenugasan(jsonSppLhp)
                    dataStatus = {
                        nomorAju: datappm.nomorAju,
                        kodeStatus: '021',
                        waktuStatus: new Date(),
                        createdBy: localStorage.getItem('username')
                    }
                    await nonLalinService.saveNonlalinStatus(JSON.stringify(dataStatus))

                }
            } else {
                setShowProsesFailed(true)
            }
        } catch (error) {
            console.log(error)
            setShowProsesFailed(true)
        }
        setLoadingSave(false)
    }

    const handleClickProsesSuccess = () => {
        setShowProsesSucces(false)
        setShowConfirmProses(false)
        handleCloseAddProses()
        reloadList(datappm.nomorAju)
    }

    const handleClickProsesFailed = () => {
        setShowProsesFailed(false)
    }

    const columns = [
        {
            name: 'Seri',
            cell: row => row['trNonlalinDtlPK'].seri,
            grow: 0
        },
        {
            name: 'Nama Dagang',
            cell: row => row['namaLokal']
        },
        {
            name: 'Nama Latin',
            cell: row => row['namaLatin']
        },
        {
            name: 'Keterangan / Populasi',
            cell: row => row['populasi']
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    {isEdit &&
                        <div className='row'>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Tambah Target Pengujian</Tooltip>}>
                                <Button size='sm' variant='primary' onClick={() => handleShowTargetUji(row)}>
                                    <FaRegPlusSquare /> Tambah Target Pengujian
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                    }
                </>
            )
        }
    ]

    const [detilKomoditi, setDetilKomoditi] = useState(null)
    const [showAddTargetUji, setShowTargetUji] = useState(false)
    const handleCloseTargetUji = () => setShowTargetUji(false)
    const handleShowTargetUji = (row) => {
        setDetilKomoditi(row)
        setShowTargetUji(true)
    }

    return (
        <>
            <Modal show={showAddProses}
                onHide={handleCloseAddProses}
                backdrop='static'
                keyboard={false}
                size="xl"
                centered
                scrollable={true}
            >
                <Modal.Header>
                    <Modal.Title>
                        <h5><NonlalinDisposisi idDisposisi={dataDisposisi.idDisposisi} /></h5>
                        {
                            datappm.maksudKegiatan !== '5' && datappm.maksudKegiatan !== '6' &&
                            <h5>Analisa Kesiapan Bahan dan Alat Lab <span className='text-danger'><b>(* untuk Layanan Laboratorium dan Layanan Cessium 137)</b></span></h5>
                        }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <div className='col-6'>
                            <label className="col-sm-6 col-form-label-sm">Nomor Aju</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.nomorAju} readOnly />
                            </div>
                        </div>
                        <div className='col-6'>
                            <label className="col-sm-6 col-form-label-sm">Tanggal Aju</label>
                            <div className="col-sm-6">
                                <input type="text" className="col-sm-12 form-control-sm" name="tanggal_aju" defaultValue={formatDateString(datappm.tanggalAju)} readOnly />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className='col-12'>
                            <label className="col-sm-4 col-form-label-sm">UPT</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={upt} readOnly />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className='col-12'>
                            <label className="col-sm-4 col-form-label-sm">Pengirim</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.namaTrader} readOnly />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className='col-6'>
                            <label className="col-sm-4 col-form-label-sm">Jenis Komoditi</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={jnsKomoditi} readOnly />
                            </div>
                        </div>
                        <div className='col-6'>
                            <label className="col-sm-4 col-form-label-sm">Maksud Kegiatan</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={maksudKegiatan} readOnly />
                            </div>
                        </div>
                    </div>
                    {
                        dataDetil &&
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                            columns={columns}
                            data={dataDetil.data}
                            highlightOnHover
                            persistTableHead={true}
                            expandableRows
                            expandOnRowDoubleClicked
                            // expandableIcon={{
                            //     collapsed: <FaPlus size={12} color="blue" />, // Custom expand icon
                            //     expanded: <FaMinus size={12} color="red" />,   // Custom collapse icon
                            // }}
                            expandableIcon={{
                                collapsed: <span style={{ color: 'blue', fontWeight: 'bold' }}>Lihat</span>,
                                expanded: <span style={{ color: 'red', fontWeight: 'bold' }}>Tutup</span>,
                            }}
                            expandableRowsComponent={({ data }) => <ExpandableComponentNonLalinPeriksa data={data} />}
                            expandableRowExpanded={() => true}
                        />
                    }
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && <Button variant="primary" size="sm" onClick={() => ProsesDisposisi(dataDisposisi)}>Proses</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseAddProses}>Batal</Button>
                </Modal.Footer>
            </Modal>

            {
                showConfirmProses &&
                <SweetAlert
                    title="Proses?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickProses}
                    onCancel={handleCloseConfirmProses}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showProsesSuccess &&
                <SweetAlert
                    title="Proses Berhasil"
                    success
                    onConfirm={handleClickProsesSuccess}
                    btnSize="sm"
                />
            }
            {
                showProsesFailed &&
                <SweetAlert
                    title="Proses Gagal"
                    danger
                    onConfirm={handleClickProsesFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
            <ModalTargetUji showAddTargetUji={showAddTargetUji} handleCloseTargetUji={handleCloseTargetUji} datakomoditi={detilKomoditi} />
        </>
    )
}

export default ModalProsesNonLalin